import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col col-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = { class: "card-text" }
const _hoisted_14 = ["src"]

import { computed, ref, watch, onMounted, onUnmounted, toRaw } from 'vue'
    import { guid } from "@app/Guid"
    import { useId } from '@common/composables'
    import { useAdminConfigureConnectorPage } from '@Integrations/Connectors/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigureConnectorPage',
  setup(__props) {

    document.title = "Configure connector"

    const id = useId()
    const { useCurrentUserQuery, useConnectorProvidersQuery, useConnectorDetailsQuery, useConfigureConnectorCommand } = useAdminConfigureConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runConnectorDetailsQueryV1, modelConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const configPageUrl = computed(() => `${provider.value?.ConfigPageUrl}${tid.value}`)
    const connectorProviderType = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorProvider?.Type)
    const connectorConfig = computed(() => modelConnectorDetailsQueryV1.value?.Config)

    const { runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1 } = useConnectorProvidersQuery(true, true)

    const { invokeConfigureConnectorCommandV1, providerType, config, succeedConfigureConnectorCommandV1 } = useConfigureConnectorCommand(id, tid, userId)

    const connectorId = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorId || guid())
    const providers = computed(() => modelConnectorProvidersQueryV1.value?.Providers)
    const provider = computed(() => providers.value?.find(_ => _.Type == providerType.value))

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(tid, (val) => {
        runConnectorProvidersQueryV1()
    })

    watch(succeedConfigureConnectorCommandV1, () => {
        if (succeedConfigureConnectorCommandV1.value) location.href = `/#/admin/integrations/connectors/details/${id}`
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': JSON.parse(JSON.stringify(toRaw(connectorConfig.value)))
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeConfigureConnectorCommandV1()
            }
        }
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure connector", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/connectors/details/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (p) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              onClick: ($event: any) => (providerType.value=p.Type),
              class: _normalizeClass(["card text-dark bg-light mb-3", { 'border-primary': _unref(providerType) == p.Type }]),
              role: "button"
            }, [
              (p.LogoUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "card-img-top m-1",
                    src: p.LogoUrl,
                    style: {"max-height":"100px"}
                  }, null, 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h5", _hoisted_12, _toDisplayString(p.Name), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_13, _toDisplayString(p.Description), 1 /* TEXT */)
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_9)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (provider.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            ref_key: "connectorProviderElement",
            ref: connectorProviderElement,
            name: "connectorProviderElement",
            src: configPageUrl.value,
            style: {"border":"none","width":"100%","height":"600px"}
          }, null, 8 /* PROPS */, _hoisted_14))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})